import { fromJS } from 'immutable';
import { storeGenerator } from '../../utils/Generator';

export default storeGenerator('AppStore', {
  handlers: {
    SET_STATUS: 'setStatus',
  },

  defaults: {
    status: {
      share_post_url: process.env.ENDPOINT,
      modal_open: false,
      modal_background: true,
      fail_to_initialize: false,
      game_interface_enabled: false, // e.g. false if modal displayed
      game_started_at: Date.now(),
      game_current_time: Date.now(),
      game_ended: (new Date('2017/01/08 20:00') - Date.now()) <= 0,
    },
  },

  setStatus({ status }) {
    this.set(['status'], this.get(['status']).merge(fromJS(status)));
  },

  getStatus({ key }) {
    return this.get(['status', key]);
  },
});



// WEBPACK FOOTER //
// ./src/app/stores/App/App.js